import {
  Users,
  FileText,
  Zap,
  Eye,
  ThumbsUp,
  MessageSquareTextIcon,
  Share2,
  HandCoins,
  IndianRupee,
  Wallet,
  CreditCard,
  PiggyBank,
} from 'lucide-react';
import type { Stat } from '../metrics/StatSection';

export const BASE_ANALYTICS_STATS: Stat[] = [
  // ── Engagement ────────────────────────────────────────────
  {
    label: 'Influencers',
    value: '42',
    icon: Users,
    iconBg: 'bg-[#4648D4]/10',
    iconColor: 'text-[#4648D4]',
    info: 'Number of creators currently active in this campaign.',
  },
  {
    label: 'Posts',
    value: '156',
    icon: FileText,
    iconBg: 'bg-[#4648D4]/10',
    iconColor: 'text-[#4648D4]',
    info: 'Total content pieces published by creators so far.',
  },
  {
    label: 'Engagement',
    value: '0',
    icon: Zap,
    iconBg: 'bg-[#B4136D]/10',
    iconColor: 'text-[#B4136D]',
    info: 'Total interactions (likes + comments + shares) across all posts.',
  },
  {
    label: 'Views',
    value: '1.1M',
    icon: Eye,
    iconBg: 'bg-[#4648D4]/10',
    iconColor: 'text-[#4648D4]',
    info: 'Total times campaign content has been watched or seen.',
  },
  {
    label: 'Total Likes',
    value: '0',
    icon: ThumbsUp,
    iconBg: 'bg-[#B4136D]/10',
    iconColor: 'text-[#B4136D]',
    info: 'Sum of all likes across every post in this campaign.',
  },
  {
    label: 'Total Comments',
    value: '0',
    icon: MessageSquareTextIcon,
    iconBg: 'bg-[#4648D4]/10',
    iconColor: 'text-[#4648D4]',
    info: 'High comment count signals strong audience intent — not just passive scrolling.',
  },
  {
    label: 'Total Shares',
    value: '0',
    icon: Share2,
    iconBg: 'bg-[#B4136D]/10',
    iconColor: 'text-[#B4136D]',
    info: 'Times content was reshared. Shares amplify reach beyond the original creator audience.',
  },
  // ── Financial ─────────────────────────────────────────────
  {
    label: 'CPV',
    value: '₹0.85',
    icon: HandCoins,
    iconBg: 'bg-[#059669]/10',
    iconColor: 'text-[#059669]',
    info: "Cost Per View — how much you're paying per video view. ₹0.006 is very efficient.",
  },
  {
    label: 'CPE',
    value: '₹2.40',
    icon: IndianRupee,
    iconBg: 'bg-[#B4136D]/10',
    iconColor: 'text-[#B4136D]',
    info: 'Cost Per Engagement — how much each like, comment, or share costs you.',
  },
  {
    label: 'Committed',
    value: '0',
    icon: Wallet,
    iconBg: 'bg-[#4648D4]/10',
    iconColor: 'text-[#4648D4]',
    info: 'Total budget locked in for confirmed creator deals.',
  },
  {
    label: 'Spent',
    value: '0',
    icon: CreditCard,
    iconBg: 'bg-[#BA1A1A]/10',
    iconColor: 'text-[#BA1A1A]',
    info: 'Amount actually paid out so far. 48.5% means roughly half the committed budget is disbursed.',
  },
  {
    label: 'Remaining',
    value: '0',
    icon: PiggyBank,
    iconBg: 'bg-[#059669]/10',
    iconColor: 'text-[#059669]',
    info: 'Budget still available to allocate to new creators or boost existing content.',
  },
];
